/**
 * Central registry of all API endpoint paths used across the theme.
 *
 * MIDDLEWARE (Guardians API — /apps/takeaction/*)
 * Any new middleware endpoint should be added here. If you add a new direct
 * fetch() call, reference the constant from this file and add a logFrontendError
 * hook in its catch block. See docs/cusa-frontend-logger_README.md for details.
 *
 * SHOPIFY CART (/cart/*)
 * Native Shopify endpoints used by cart helpers in global.js.
 */
const CUSA_ENDPOINTS = {
	// Guardians API
	frontendLogs: '/apps/takeaction/frontend_logs',
	petitionSignatures: '/apps/takeaction/petition_signatures',
	clicks: '/apps/takeaction/clicks',
	allClicks: '/apps/takeaction/all_clicks',
	accountInfo: '/apps/takeaction/account_info',
	redemptions: '/apps/takeaction/redemptions',
	memberships: '/apps/takeaction/memberships',
	shelterVote: '/apps/takeaction/shelters/vote',
	awards: '/apps/takeaction/awards',

	// Shopify cart
	cart: '/cart.js',
	cartUpdate: '/cart/update.js'
};
